import { GzNetworkAttackWebComponent } from './component/NetworkAttackWebComponent';

export { GzNetworkAttackWebComponent };
